





















import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import UiIconComponent from '@/app/shared/components/ui/ui-icon-component.vue';

@Component({
  components: {
    UiIconComponent
  }
})
export default class UiPagerComponent extends Vue {
  @Prop({
    default: 0
  })
  public currentPage: number = 0;

  @Prop({
    default: 0
  })
  public allPages: number;

  public currentPageInternal: number = this.currentPage;

  public get isFirst(): boolean {
    return this.currentPageInternal === 1;
  }

  public get isLast(): boolean {
    return this.currentPageInternal === this.allPages;
  }

  @Watch('currentPage')
  public onCurrentPageChanged(newValue: number): void {
    this.currentPageInternal = newValue;
  }

  public onPrevClicked(): void {
    if (this.isFirst) {
      return;
    }

    this.currentPageInternal--;
    this.emitPaged();
  }

  public onNextClicked(): void {
    if (this.isLast) {
      return;
    }

    this.currentPageInternal++;
    this.emitPaged();
  }

  @Emit('paged')
  public emitPaged(): number {
    return this.currentPageInternal;
  }

  @Emit('mounted')
  private mounted() {
    return {
      prev: this.onPrevClicked,
      next: this.onNextClicked,
    }
  }
}
